import React from 'react'
import './lookcourse.css'
import { connect } from 'react-redux'
import {update} from "../../../redux/user_redux";
@connect(
    state=>state.user,
    {update}
)
class Preview extends React.Component{
    render(){
        const isMobile = this.props.data.isMobile
        return (
            <div class={isMobile?'container_mobile_preview':'container'}>
                <img id="img-set" src={require('./images/lookpreview.png')} alt=""/>
            </div>
        )
    }

}
export default Preview